import { put, select } from 'redux-saga/effects';
import { getCoverDetail, getExcess } from './set_excess_by_state';

/**
 * Generator/Saga to set requestedExcess to the quote from onClick event emmited by "Level of insuranse"
 * filter on the result page based on selected state from overnight parking address
 * @param {Object} action - 'SET_EXCESS_BY_STATE_FILTER' action
 */
const setExcessByStateSelector = function* (action) {
    if (action.filter && action.filterStaged) {
        const requestedExcessValue = yield select(requestedExcessByStateCodeSelector);
        yield put({
            type: 'SET_FILTER_VALUE',
            filter: action.filter,
            filterStaged: action.filterStaged,
            filterValue: requestedExcessValue
        });
    }
};

export const requestedExcessByStateCodeSelector = (state) => {
    const coverDeail = getCoverDetail(state);
    const stateCode = coverDeail.getIn(['overnightParking', 'address', 'state']);
    return getExcess(stateCode);
};

export default ['SET_EXCESS_BY_STATE_FILTER', setExcessByStateSelector];
